import { useState } from 'react';
import NovaChat from "../../components/NovaChat";

export default function ConsultaDocenteNova({ apiUrl, apiKey, domain, companyId, userName, userId }) {

  const [chatVisible, setChatVisible] = useState(true);

  const openChat = () => {
    setChatVisible(true);
  };

  const closeChat = () => {
    setChatVisible(false);
  };

  return (
    <div className="chat-zegel">    
      {chatVisible && (
        <NovaChat
          apiUrl={apiUrl}
          apiKey={apiKey}
          domain={domain}
          companyId={companyId}
          userName={userName}
          userId={userId}
          onClose={closeChat}
        />
      )}
    </div>
  );
}
